var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtaskNotExpanded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.39276L0 0.607239C3.33974e-05 0.487132 0.0464399 0.369729 0.133353 0.269871C0.220267 0.170013 0.343785 0.0921855 0.488291 0.046226C0.632798 0.000266552 0.791806 -0.0117617 0.945213 0.0116634C1.09862 0.0350881 1.23954 0.0929141 1.35016 0.17783L5.76842 3.57059C5.9167 3.68449 6 3.83895 6 4C6 4.16105 5.9167 4.31551 5.76842 4.42941L1.35016 7.82217C1.23954 7.90709 1.09862 7.96491 0.945213 7.98834C0.791806 8.01176 0.632798 7.99973 0.488291 7.95377C0.343785 7.90781 0.220267 7.82999 0.133353 7.73013C0.0464399 7.63027 3.33974e-05 7.51287 0 7.39276Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtaskNotExpanded);
export default __webpack_public_path__ + "static/media/subtaskNotExpanded.f24b8b157650dde8b06c9e88b9d8f396.svg";
export { ForwardRef as ReactComponent };